import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Zap, Instagram, Facebook, Link2, Loader2 } from "lucide-react";
import { Button } from "../../ui/button";

export const MetaOptionCard = ({ metaStatus, publishingMeta, publishMeta }) => {
  const navigate = useNavigate();
  return (
    <div
      data-testid="option-a"
      className={`rounded-2xl border p-5 transition-all ${metaStatus?.connected ? "border-yellow-400/60 bg-yellow-400/5" : "border-white/10 bg-[#121212]"}`}
    >
      <div className="flex items-center justify-between">
        <Zap className="text-yellow-400" size={24} />
        {metaStatus?.connected
          ? <span className="text-[10px] uppercase tracking-wider bg-green-500/15 text-green-400 px-2 py-0.5 rounded-full font-bold">Conectado</span>
          : <span className="text-[10px] uppercase tracking-wider bg-zinc-500/15 text-zinc-400 px-2 py-0.5 rounded-full font-bold">Requiere conectar</span>}
      </div>
      <h3 className="font-display font-bold text-lg mt-3">⚡ Opción A: Publicación Automática</h3>
      <p className="text-sm text-zinc-400 mt-1">Publica tu imagen y texto en Instagram y Facebook con un clic.</p>

      {metaStatus?.connected ? (
        <div className="mt-4 space-y-2">
          <Button data-testid="publish-meta-both" onClick={() => publishMeta(["instagram", "facebook"])} disabled={publishingMeta} className="w-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-xl">
            {publishingMeta ? <Loader2 className="animate-spin mr-2" size={16} /> : <Zap size={16} className="mr-2" />} Publicar ahora (IG + FB)
          </Button>
          <div className="flex gap-2">
            <Button data-testid="publish-meta-ig" onClick={() => publishMeta(["instagram"])} disabled={publishingMeta} variant="outline" className="flex-1 border-pink-500/40 text-pink-300 hover:bg-pink-500/10 rounded-xl">
              <Instagram size={15} className="mr-1.5" /> Instagram
            </Button>
            <Button data-testid="publish-meta-fb" onClick={() => publishMeta(["facebook"])} disabled={publishingMeta} variant="outline" className="flex-1 border-blue-500/40 text-blue-300 hover:bg-blue-500/10 rounded-xl">
              <Facebook size={15} className="mr-1.5" /> Facebook
            </Button>
          </div>
          <span onClick={(e) => { e.stopPropagation(); toast.message("TikTok: próximamente."); }} className="block text-center text-xs text-zinc-500 hover:text-purple-400 cursor-pointer pt-1">TikTok (próximamente)</span>
        </div>
      ) : (
        <Button data-testid="connect-redes-cta" onClick={() => navigate("/dashboard/redes")} className="mt-4 w-full bg-[#1877F2] hover:bg-[#1568d8] text-white font-bold rounded-xl">
          <Link2 size={16} className="mr-2" /> Conectar Instagram / Facebook
        </Button>
      )}
    </div>
  );
};
